<template>
  <el-table
    class="k-foundations-list"
    :data="foundations"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <el-table-column label="Активний" width="100">
      <template slot-scope="scope">
        <div
          class="k-foundations-list__status"
          :class="{
            'is-active' : scope.row.active,
          }"
        >
        </div>
      </template>
    </el-table-column>

    <el-table-column
      class="k-foundations-list__value"
      prop="_id"
      label="id"
      width="250"
    >
    </el-table-column>

    <el-table-column
      class="k-foundations-list__value"
      prop="title"
      label="Название"
    >
    </el-table-column>

   <el-table-column label="Action" width="100">
      <template slot-scope="scope">
        <el-tooltip content="Редактировать" placement="top">
          <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-foundations-list - Отображает список точек карты

*
* @version 1.0.0
*/

import formatDate from '@/util/formatDate';


export default {
  name: 'k-foundations-list',

  props: {
    // Массив всех точек
    foundations: {
      type: Array,
    },
  },

  methods: {
    // Класс для стрки, используется для расскарски строк таблицы в разные цвета
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    // Редактирование точки
    handleEdit(data) {
      this.$emit('edit', data._id)
    },

    // Удаление точки
    handleDelete(data) {
      console.log('handleDelete');
      this.$emit('delete', data._id)
    },

    // Форматирование даты
    formatDate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-foundations-list {
  $this: &;

  &__status {
    width: 12px;
    height: 12px;
    background-color: #909399;
    border-radius: 6px;

    &.is-active {
      background-color: #67C23A;
    }
  }

  &__value {
    font-size: 10px;
  }
}
</style>
